import { alias, deserialize, serializable } from 'serializr';
export class UserActivity {
  @serializable
  public id: number;
  @serializable
  public firstName: string;
  @serializable
  public lastName: string;
  @serializable(alias('identityServiceUUId'))
  public identityServiceId: string;

  get name() {
    if (this.firstName == null && this.lastName == null) {
      return '';
    }
    return `${this.firstName || ''} ${this.lastName || ''}`;
  }
  deserialize(input: any): this {
    return Object.assign(this, deserialize(UserActivity, input));
  }
}
